import axios from "axios";
import apiUrlConfig from "../../environmentSettings";

export const getOrganization = organizationId => {
	let accessToken = localStorage.getItem("$LoopBack$accessTokenId");
	return axios
		.get(`${apiUrlConfig.apiConfig.p3fyUrl}/organizations/findOne`, {
			headers: { Authorization: accessToken },
			params: {
				filter: {
					where: {
						id: organizationId
					}
				}
			}
		})
		.then(function(response) {
			return response.data;
		});
};

export const getOrganizationUser = (organizationId, idUser) => {
	let accessToken = localStorage.getItem("$LoopBack$accessTokenId");
	let userId = idUser ? idUser : localStorage.getItem("$LoopBack$currentUserId");

	return axios
		.get(`${apiUrlConfig.apiConfig.p3fyUrl}/organizationUsers/findOne`, {
			headers: { Authorization: accessToken },
			params: {
				filter: {
					where: {
						userId: userId,
						organizationId: organizationId
					},
					include: "user"
				}
			}
		})
		.then(function(response) {
			return response.data;
		})
		.catch(err => {
			return err;
		});
};
